var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"message-box","size":"sm","hide-header":"","hide-footer":""}},[_c('p',{staticClass:"my-2 text-center"},[_vm._v(_vm._s(_vm.$t('security.messageBox.text')))])])}
var staticRenderFns = []

export { render, staticRenderFns }